/* eslint-disable react/destructuring-assignment */
import { IconNotes, IconTruck } from '@tabler/icons-react';
import { Paper, SimpleGrid, Space, Textarea, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { VehicleType } from '../../../../../models/core/vehicles.type';
import { Feature } from '../../../../../utils/constants.utils';
import PageSection from '../../../../../components/core/PageSection/PageSection';

type FormViewData = {
  idResiduoVeiculo: number | null;
  residuoVeiculo: string;
  descricao: string | null;
};

type FormViewProps = {
  save(data: FormViewData): void;
  vehicle: VehicleType | null;
  loading: boolean;
};

function FormView(props: FormViewProps) {
  const form = useForm<FormViewData>({
    initialValues: {
      idResiduoVeiculo: props.vehicle?.idResiduoVeiculo || null,
      residuoVeiculo: props.vehicle?.residuoVeiculo || '',
      descricao: props.vehicle?.descricao || '',
    },
    validate: {
      residuoVeiculo: (value) => (value.trim() !== '' ? null : 'Campo obrigatório'),
    },
  });

  const handleSubmit = async (formData: FormViewData) => {
    props.save({
      ...formData,
      residuoVeiculo: formData.residuoVeiculo.trim(),
      descricao: formData.descricao?.trim() || null,
    });
  };

  return (
    <form id="vehicle-add-edit" onSubmit={form.onSubmit(handleSubmit)} noValidate>
      <Paper shadow="xs" p="md" withBorder>
        <PageSection size="lg" color={Feature.Reference.Vehicle.color} label="Geral" text="" />
        <Space h="xs" />
        <SimpleGrid cols={5}>
          <TextInput
            leftSection={<IconTruck size={15} />}
            label="Veículo"
            placeholder="Nome do veículo"
            maxLength={50}
            required
            {...form.getInputProps('residuoVeiculo')}
          />
        </SimpleGrid>
        <Space h="xs" />
        <Textarea
          leftSection={<IconNotes size={15} />}
          label="Descrição"
          placeholder="Descrição do veículo"
          autosize
          maxLength={500}
          {...form.getInputProps('descricao')}
        />
      </Paper>
    </form>
  );
}

export { FormView };
export type { FormViewData };
